// @flow
import * as Immutable from 'immutable'; // This is required
import ImmutableModel from './ImmutableModel'; // Make sure you copied this file into your repo

import type { LatLngModelType } from './LatLng';
import type { AuditMetadataModelType } from 'common/models/flow/AuditMetadata';

export type LatLngFeedbackModelType = {
    latLng: LatLngModelType
};

export type ReasonModelType = {
    message: string,
    createdBy: string,
    createdOn: string,
    feedbackSource: string
};

export type ZoneFeedbackModelType = {
    feedbackStatus: string,
    routeId: string,
    reasons: Array<ReasonModelType>
};

export type IntelliSortFeedbackModelType = {
    auditMetadata: ?AuditMetadataModelType,
    latLngFeedback: LatLngFeedbackModelType,
    zoneFeedback: ZoneFeedbackModelType
};

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class LatLngFeedback extends ImmutableModel {
    static fromJS(json: LatLngFeedbackModelType): LatLngFeedback {
        const state: Object = Object.assign({}, json);
        state.latLng = LatLng.fromJS(state.latLng);
        return new this(Immutable.Map(state));
    }

    toJS(): LatLngFeedbackModelType {
        return {
            latLng: this.latLng.toJS()
        };
    }

    get latLng(): LatLng {
        return this._state.get('latLng');
    }

    setLatLng(latLng: LatLng): this {
        return this.clone(this._state.set('latLng', latLng));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class Reason extends ImmutableModel {
    static fromJS(json: ReasonModelType): Reason {
        const state: Object = Object.assign({}, json);
        return new this(Immutable.Map(state));
    }

    toJS(): ReasonModelType {
        return {
            message: this.message,
            createdBy: this.createdBy,
            createdOn: this.createdOn,
            feedbackSource: this.feedbackSource
        };
    }

    get message(): string {
        return this._state.get('message');
    }

    setMessage(message: string): this {
        return this.clone(this._state.set('message', message));
    }

    get createdBy(): string {
        return this._state.get('createdBy');
    }

    setCreatedBy(createdBy: string): this {
        return this.clone(this._state.set('createdBy', createdBy));
    }

    get createdOn(): string {
        return this._state.get('createdOn');
    }

    setCreatedOn(createdOn: string): this {
        return this.clone(this._state.set('createdOn', createdOn));
    }

    get feedbackSource(): string {
        return this._state.get('feedbackSource');
    }

    setFeedbackSource(feedbackSource: string): this {
        return this.clone(this._state.set('feedbackSource', feedbackSource));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class ZoneFeedback extends ImmutableModel {
    static fromJS(json: ZoneFeedbackModelType): ZoneFeedback {
        const state: Object = Object.assign({}, json);
        state.reasons = Immutable.List(state.reasons).map(item =>
            Reason.fromJS(item)
        );
        return new this(Immutable.Map(state));
    }

    toJS(): ZoneFeedbackModelType {
        return {
            feedbackStatus: this.feedbackStatus,
            routeId: this.routeId,
            reasons: this.reasons.toArray().map(item => item.toJS())
        };
    }

    get feedbackStatus(): string {
        return this._state.get('feedbackStatus');
    }

    setFeedbackStatus(feedbackStatus: string): this {
        return this.clone(this._state.set('feedbackStatus', feedbackStatus));
    }

    get routeId(): string {
        return this._state.get('routeId');
    }

    setRouteId(routeId: string): this {
        return this.clone(this._state.set('routeId', routeId));
    }

    get reasons(): Immutable.List<Reason> {
        return this._state.get('reasons');
    }

    setReasons(reasons: Immutable.List<Reason>): this {
        return this.clone(this._state.set('reasons', reasons));
    }
}

// /////////////////////////////////////////////////////////////////////////////
//
// NOTE: THIS CLASS IS GENERATED. DO NOT MAKE CHANGES HERE.
//
// If you need to update this class, update the corresponding flow type above
// and re-run the flow-immutable-models codemod
//
// /////////////////////////////////////////////////////////////////////////////
export class IntelliSortFeedback extends ImmutableModel {
    static fromJS(json: IntelliSortFeedbackModelType): IntelliSortFeedback {
        const state: Object = Object.assign({}, json);
        state.auditMetadata = state.auditMetadata
            ? AuditMetadata.fromJS(state.auditMetadata)
            : state.auditMetadata;
        state.latLngFeedback = LatLngFeedback.fromJS(state.latLngFeedback);
        state.zoneFeedback = ZoneFeedback.fromJS(state.zoneFeedback);
        return new this(Immutable.Map(state));
    }

    toJS(): IntelliSortFeedbackModelType {
        return {
            auditMetadata: this.auditMetadata
                ? this.auditMetadata.toJS()
                : this.auditMetadata,
            latLngFeedback: this.latLngFeedback.toJS(),
            zoneFeedback: this.zoneFeedback.toJS()
        };
    }

    get auditMetadata(): ?AuditMetadata {
        return this._state.get('auditMetadata');
    }

    setAuditMetadata(auditMetadata: ?AuditMetadata): this {
        return this.clone(this._state.set('auditMetadata', auditMetadata));
    }

    get latLngFeedback(): LatLngFeedback {
        return this._state.get('latLngFeedback');
    }

    setLatLngFeedback(latLngFeedback: LatLngFeedback): this {
        return this.clone(this._state.set('latLngFeedback', latLngFeedback));
    }

    get zoneFeedback(): ZoneFeedback {
        return this._state.get('zoneFeedback');
    }

    setZoneFeedback(zoneFeedback: ZoneFeedback): this {
        return this.clone(this._state.set('zoneFeedback', zoneFeedback));
    }
}
